<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header"> Bienvenidos a la Contraloría Dental de Codelco Teniente.</div>
          <div class="card-body">
            <p>
              Nuestras oficinas están ubicadas en Avenida Miguel Ramirez #140. Esto es, frente a la Isapre Colmena. <br/><br/>

              Los horarios atención son Lunes, Miércoles y Viernes en la tarde de 16:30 a 19:30 hrs. Miércoles en la mañana de 10:30 a 12:30 hrs.<br/><br/>

              Nuestro Teléfono fijo +56 72 2226550 y nuestro whatsap es +56 9 42771012.<br/><br/>

              El e-mail habilitado hoy día para atención es dentistacontralor@gmail.com<br/><br/>

              El tutorial para el proceso de aprobación lo puedes ver desde el siguiente enlace: <a href="https://youtu.be/Shb7dQikyDc" target="_blank">Ver Aquí</a>

            </p>
          <div class="card" style="width: 18rem;">
            <img class="card-img-top" src="/static/1.jpg" alt="Card image cap">
            <div class="card-body">
              <p class="card-text">Dr. Carlos Eduardo Soto Pérez</p>
            </div>
        </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="maps_address">
          <iframe id="imObjectMap_3_frame" style="overflow: hidden; border: none;" src="https://maps.google.es/maps?hl=es&amp;f=q&amp;source=s_q&amp;geocode=&amp;q=Bueras+359,+Rancagua&amp;t=m&amp;ie=UTF8&amp;hq=&amp;hnear=Bueras+359,+Rancagua&amp;z=15&amp;output=embed"></iframe>
        </div>
        <div class="card">
          <div class="card-header">Contactanos</div>
          <div class="table-responsive">
            <table class="table table-hover">
              <tr>
                <th>Llámenos:</th>
                <th>
                  <i class="fa fa-phone"></i> 72 2 226550
                </th>
              </tr>
              <tr>
                <th>Whatsapp:</th>
                <th>
                  <i class="fab fa-whatsapp"></i> +56 9 427 710 12
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  Avenida Miguel Ramirez #140
                </th>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeComponent',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/HomeComponent.vue